import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { ChartDefinition } from 'src/shared/models/chart-definintions.model';
import { Chart } from 'angular-highcharts';
import { ReportService } from 'src/shared/services/report.service';
import { ReportData } from 'src/shared/models/report-data.model';
import { Observable, Subscription, from } from 'rxjs';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
  selector: 'smt-reasonsforvariancereport',
  templateUrl: './reasons-for-variance-report.component.html',
  styleUrls: ['./reasons-for-variance-report.component.scss']
})
export class ReasonsForVarianceReportComponent implements OnInit {

  reasonsForVarianceChart : Chart;
  reasonsForVarianceData: ReportData;
  chartDefinition: ChartDefinition = new ChartDefinition();
  loading:boolean;
  reportSubscription : Subscription;
  
  private expandEventsSubscription: any;
  private filterEventSubscription: any;

  @Input() filtersUpdated: Observable<void>;
  @Input() reportFilters:ReportFilters;

  @Output() reasonsForVarianceDataUpdated = new EventEmitter();
  constructor(private _reportService:ReportService) { }

  ngOnInit() {
    this.drawEmpty();
    this.loading = true;
    if (this.filtersUpdated)
      this.filterEventSubscription = this.filtersUpdated.subscribe(() => this.getData());
  }

  drawEmpty()
  {
    this.reasonsForVarianceChart = this.chartDefinition.getColumnTemplate
      (
        'Reasons for Variance by Pay Period Ending',
        'Pay Period Ending',
        'Hours',
        []
      );

  }
  drawGrid()
  {
    this.loading = false;
    const minRows:number = 5;

    if(!this.reasonsForVarianceData)
      return;

    let chartData = MiscUtil.getDataFilteredByDataSetName(this.reasonsForVarianceData);

    this.reasonsForVarianceChart = this.chartDefinition.getColumnTemplate
      (
        'Reasons for Variance by Pay Period Ending',
        'Pay Period Ending',
        'Hours',
        this.reasonsForVarianceData.xAxis
      );

    if (chartData.length == 0)
      return;

    let chartSizeMinusOne = chartData.length - 1;

    // Add all but the last entry with the re-draw flag set to false this speeds up chart drawing
    chartData.slice(0,chartSizeMinusOne).forEach(dataSet =>
      {
        this.reasonsForVarianceChart.addSeries({type: 'column', name: dataSet.name, 	data:  dataSet.data},false,true);
      });

    this.reasonsForVarianceChart.addSeries({type: 'column', name: chartData[chartSizeMinusOne].name, 	data:  chartData[chartSizeMinusOne].data},true,true);

  }

  async getData()
  {

    this.loading = true;

    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();

    this.reportSubscription = from(this._reportService.getReasonsForVarianceReport(this.reportFilters))
                                                      .subscribe(x =>
                                                      {
                                                        this.reasonsForVarianceData = x;
                                                        this.reasonsForVarianceDataUpdated.emit(this.reasonsForVarianceData);
                                                        this.drawGrid();
                                                      });
  }

  ngOnDestroy() {
    if(this.filtersUpdated)
      this.filterEventSubscription.unsubscribe();
    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();
  }
}
